import { createAction, props } from '@ngrx/store';

export const RECOMMENDED_CARRIERS = {
	RELOAD_SEARCH: createAction('[Project details] Reload recommended carriers view', props<any>()),

	SEARCH_LANES: createAction('[Project details] Search lanes capacity search', props<any>()),
	SEARCH_LANES_SUCCESS: createAction(
		'[Project details] Search lanes capacity search success',
		props<any>()
	),
	SEARCH_LANES_FAILURE: createAction(
		'[Project details] Search lanes capacity search failure',
		props<any>()
	),

	SET: {
		NUMBER_OF_LANES: createAction('[Project details] Set number of lanes', props<any>()),
		TRUCK_LANE_SEARCH_ID: createAction('[Project details] Set truck lane search id', props<any>()),
		USER_CARRIER: {
			MAP: createAction('[Project details] Set user carriers map', props<any>()),
			LIST: createAction('[Project details] Set user carriers map list', props<any>()),
		},
		TRUCK_SEARCH_RESULT: createAction('[Project details] Set truck search result', props<any>()),
		ALL_CAPACITY_SEARCH_RESULT: createAction(
			'[Project details] Set all capacity search results',
			props<any>()
		),
		CAPACITY_SEARCH_RESULT: createAction(
			'[Project details] Set capacity search results',
			props<any>()
		),
		PROJECTS_FOR_CARRIERS_LIST: createAction(
			'[Project details] Set projects for carreirs list',
			props<any>()
		),
		ACCOUNT_CARRIER_LANES: createAction(
			'[Project details] Set recommended carriers account carrier lanes',
			props<any>()
		),
		CARRIER_PROJECT_MAP: createAction('[Project details] Set carriers project map', props<any>()),
		BEST_MATCH: createAction(
			'[Project details] Set recommended carriers search best match',
			props<any>()
		),
		CAPACITY_SEARCH_SORT: createAction('[Project details] Set capacitySearch sort', props<any>()),
		MATCHED_CARRIER_HQ_IDS: createAction(
			'[Project details] Set matched carrier hq ids',
			props<any>()
		),
		CARRIER_SEARCH: createAction('[Project details] Set carrier search filter', props<any>()),
	},

	CAPACITY_SEARCH: {
		DOWNLOAD_CSV: createAction('[Project details] Download capacity search csv', props<any>()),
		DOWNLOAD_COMPLETE: createAction(
			'[Project details] Download capacity search csv complete',
			props<any>()
		),
	},

	ENGAGE_WITH_CARRIERS: {
		START: createAction('[Project details] Start engaged carriers flow', props<any>()),
		OPEN_DIALOG: createAction('[Project details] Open carrier note and rate dialog', props<any>()),
		CLOSE: createAction('[Project details] Close carrier note and rate dialog', props<any>()),
		CREATE: createAction(
			'[Project details] Create project carrier map with status in_progress',
			props<any>()
		),
		SUCCESS: createAction('[Project details] Create engaged carriers success', props<any>()),
		FAILURE: createAction(
			'[Project details] Create engaged carriers failure',
			props<{ payload: { message: string } }>()
		),
		UPDATE_USER_SETTING: createAction(
			'[Project details] Update engaged carriers modal user setting',
			props<any>()
		),
		UPDATE_USER_SETTING_SUCCESS: createAction(
			'[Project details] Successfully updated engaged carriers modal user setting',
			props<any>()
		),
		UPDATE_USER_SETTING_FAILURE: createAction(
			'[Project details] Failed to update engaged carriers modal user setting',
			props<any>()
		),

	},

	PROCURE_CARRIERS: {
		CREATE: createAction(
			'[Project details] Move carrier from recommended to procure',
			props<any>()
		),
		SUCCESS: createAction(
			'[Project details] Move carrier from recommended to procure success',
			props<any>()
		),
		FAILURE: createAction(
			'[Project details] Move carrier from recommended to procure failure',
			props<{ payload: { message: string } }>()
		),
	},
};
